import { z } from "zod";
import { COMMENT_TEXT_MAX_LENGTH } from "../../constants/limits.js";
export const StoryViewerStateSchema = z.object({
    liked: z.boolean(),
    bookmarked: z.boolean(),
});
export const StoryLikeStateSchema = z.object({
    liked: z.boolean(),
    likes: z.number().int().nonnegative(),
});
export const StoryBookmarkStateSchema = z.object({
    bookmarked: z.boolean(),
    bookmarks: z.number().int().nonnegative(),
});
export const StoryCommentAuthorSchema = z.object({
    id: z.uuid(),
    displayName: z.string(),
    avatarUrl: z.url().nullable(),
});
export const StoryCommentSchema = z.object({
    id: z.uuid(),
    storyId: z.uuid(),
    text: z.string(),
    createdAt: z.string(),
    author: StoryCommentAuthorSchema,
});
export const StoryCommentListSchema = z.object({
    comments: z.array(StoryCommentSchema),
});
export const createCommentSchema = z.object({
    text: z.string().trim().min(1).max(COMMENT_TEXT_MAX_LENGTH),
});
